import api from '../../services/api';

const state = {
  activations: [],
  total: 0,
  page: 1,
  pageSize: 50,
  loading: false,
  anomalies: [],
  anomalyWindowMinutes: 60,
};

const getters = {
  allActivations: s => s.activations,
  total: s => s.total,
  isLoading: s => s.loading,
  flaggedAnomalies: s => s.anomalies,
};

const actions = {
  async fetchActivations({ commit }, { license_id, customer_id, status, page = 1, page_size = 50 } = {}) {
    commit('SET_LOADING', true);
    try {
      const qs = new URLSearchParams();
      if (license_id) qs.append('license_id', license_id);
      if (customer_id) qs.append('customer_id', customer_id);
      if (status) qs.append('status', status);
      qs.append('page', page);
      qs.append('page_size', page_size);
      const res = await api.get(`/activations?${qs.toString()}`);
      commit('SET_ACTIVATIONS', res.data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to fetch' };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async revokeActivation({ dispatch, state }, { id, reason }) {
    try {
      await api.post(`/activations/${id}/revoke`, { reason });
      // Refresh the current view.
      return await dispatch('fetchActivations', {
        page: state.page, page_size: state.pageSize,
      });
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to revoke' };
    }
  },

  async fetchAnomalies({ commit }, { minutes = 60 } = {}) {
    try {
      const res = await api.get(`/activations/_/anomalies?minutes=${minutes}`);
      commit('SET_ANOMALIES', { flagged: res.data.flagged, window_minutes: res.data.window_minutes });
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to fetch anomalies' };
    }
  },
};

const mutations = {
  SET_ACTIVATIONS(s, payload) {
    s.activations = payload.activations || [];
    s.total = payload.total || 0;
    s.page = payload.page || 1;
    s.pageSize = payload.page_size || 50;
  },
  SET_LOADING(s, v) { s.loading = v; },
  SET_ANOMALIES(s, { flagged, window_minutes }) {
    s.anomalies = flagged || [];
    s.anomalyWindowMinutes = window_minutes;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
